import { notificationApiUrl, type GetToken } from './previewNotifications';

export type LabsUpdatesStatus = 'SUBSCRIBED' | 'UNSUBSCRIBED' | 'NOT_SPECIFIED' | 'UNSUBSCRIBED_ALL';
export interface LabsUpdatesPreference { status: LabsUpdatesStatus; managePreferencesUrl?: string }

export async function labsUpdates(getToken: GetToken, signal: AbortSignal, subscribed?: boolean): Promise<LabsUpdatesPreference> {
  const token = await getToken();
  if (!token) throw new Error('Sign in to manage Labs updates.');
  const field = subscribed === undefined ? 'labsUpdatesSubscription' : 'userSetLabsUpdatesSubscription';
  const query = subscribed === undefined
    ? 'query LabsUpdates { labsUpdatesSubscription { status managePreferencesUrl } }'
    : 'mutation LabsUpdates($subscribed: Boolean!) { userSetLabsUpdatesSubscription(subscribed: $subscribed) { status managePreferencesUrl } }';
  const response = await fetch(notificationApiUrl(window.location.hostname), {
    method: 'POST', signal, credentials: 'omit', cache: 'no-store',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ query, variables: subscribed === undefined ? {} : { subscribed } }),
  });
  if (!response.ok) throw new Error('Labs updates unavailable.');
  const body = await response.json() as { errors?: unknown[]; data?: Record<string, LabsUpdatesPreference> };
  const preference = body.data?.[field];
  if (!preference || body.errors?.length || !['SUBSCRIBED', 'UNSUBSCRIBED', 'NOT_SPECIFIED', 'UNSUBSCRIBED_ALL'].includes(preference?.status ?? '')) throw new Error('Labs updates unavailable.');
  // Preference links are personal. They are never put in analytics or local storage.
  let managePreferencesUrl: string | undefined;
  if (typeof preference.managePreferencesUrl === 'string') {
    try {
      const url = new URL(preference.managePreferencesUrl);
      if (url.protocol === 'https:' && !url.username && !url.password) managePreferencesUrl = url.href;
    } catch { /* A malformed optional link must not hide the subscription status. */ }
  }
  return { status: preference.status, managePreferencesUrl };
}
